import { render, staticRenderFns } from "./FuncionalidadeAgrupadora.vue?vue&type=template&id=2aa0594a&scoped=true&"
import script from "./FuncionalidadeAgrupadora.vue?vue&type=script&lang=js&"
export * from "./FuncionalidadeAgrupadora.vue?vue&type=script&lang=js&"
import style0 from "./FuncionalidadeAgrupadora.vue?vue&type=style&index=0&id=2aa0594a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa0594a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCheckbox,VIcon,VSwitch})
